module.exports = __webpack_public_path__ + "img/img_hongbao.daaf3472.png";